
/**
 * API認証情報を保持、永続化する
 */
class ApiConfig {

    constructor() {

        //this.authCode = ""

        this.defaultApiOption = {
            authCheck:true, // 認証状態の確認を行う
            onUnauthorized:function(){
                // ログイン画面へ遷移する
                //window.location.href = "/"; 
                console.log("onUnauthorized called");
            },
        };
    }

    get authCode() {
        let at = this.getAccessToken();
        if (at){
            return at.jwtToken;
        }
        return "";
    }

    getAuthTokenSet() {
        let idToken = this.getIdToken();
        let accessToken = this.getAccessToken();
        let refreshToken = this.getRefreshToken();

        return {
            idToken: idToken,
            accessToken: accessToken,
            refreshToken: refreshToken,
        };

    }

    setAuthTokenSet(tokenSet){
        let idToken = tokenSet.idToken;
        let accessToken = tokenSet.accessToken;
        let refreshToken = tokenSet.refreshToken;

        console.log("setAuthTokenSet id",idToken);
        console.log("setAuthTokenSet access",accessToken);

        if (!refreshToken) {
            console.log("tokenSet",tokenSet);
            throw "refreshTokenが設定されていません。";            
        }

        this.setIdToken(idToken);
        this.setAccessToken(accessToken);
        this.setRefreshToken(refreshToken);
    }

    setIdToken(tokeContainer) {
        let token = tokeContainer.jwtToken;
        let expiresAt = tokeContainer.expiresAt;        
        window.sessionStorage.setItem("idToken.token",token);
        window.sessionStorage.setItem("idToken.expiresAt",expiresAt);
    }

    getIdToken(){
        let token = window.sessionStorage.getItem("idToken.token");
        let expiresAt = window.sessionStorage.getItem("idToken.expiresAt");
        
        if (!token) return null;
        
        return {
            jwtToken:token,
            expiresAt:expiresAt,
        };
    }

    setAccessToken(tokeContainer) {
        let token = tokeContainer.jwtToken;
        let expiresAt = tokeContainer.expiresAt;        
        window.sessionStorage.setItem("accToken.token",token);
        window.sessionStorage.setItem("accToken.expiresAt",expiresAt);
    }

    getAccessToken(){
        let token = window.sessionStorage.getItem("accToken.token");
        let expiresAt = window.sessionStorage.getItem("accToken.expiresAt");
        
        if (!token) return null;
        
        return {
            jwtToken:token,
            expiresAt:expiresAt,
        };
    }

    setRefreshToken(tokeContainer) {
        let token = tokeContainer.token;
        let expiresAt = tokeContainer.expiresAt;  
        let userId = tokeContainer.userId;      
        window.localStorage.setItem("refreshToken.token",token);
        window.localStorage.setItem("refreshToken.expiresAt",expiresAt);
        window.localStorage.setItem("refreshToken.userId",userId);
    }

    getRefreshToken(){
        let token = window.localStorage.getItem("refreshToken.token");
        let expiresAt = window.localStorage.getItem("refreshToken.expiresAt");
        let userId = window.localStorage.getItem("refreshToken.userId");
        
        if (!token) return null;
        
        return {
            token:token,
            userId:userId,
            expiresAt:expiresAt,
        };
    }

    clear(){
        window.sessionStorage.removeItem("idToken.token");
        window.sessionStorage.removeItem("idToken.expiresAt");

        window.sessionStorage.removeItem("accToken.token");
        window.sessionStorage.removeItem("accToken.expiresAt");

        window.localStorage.removeItem("refreshToken.token");
        window.localStorage.removeItem("refreshToken.expiresAt");
        window.localStorage.removeItem("refreshToken.userId");
    }

}

export default new ApiConfig();